export const validateContactData = (data) => {
  if (!Array.isArray(data)) {
    return Array(5).fill("");
  }
  data = data.slice(0, 5);
  while (data.length < 5) {
    data.push("");
  }

  return data.map((item) => (item === null ? "" : item));
}

export const isValidDomain = (domain) => {
  const regex = /^(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/;
  return regex.test(domain);
}

export const isValidNumber =(param) => {
  const regex = /^[1-9]\d*(\.\d+)?$/;
  return typeof param !== 'undefined' && regex.test(param);
}